import maButtonsNextActions from '@/components/button-blue'
import maAccordion from '@/components/accordion'
import maModal from '@/components/modal'
import maNavbarStepper from '@/components/navbarStepper'
import { mapState, mapActions, mapMutations } from 'vuex'
import downloadBlobFile from '@/utils/downloadBlobFile'

import { apiGetUpptecPdf } from '@/modules/Claim/services/pdf'
import { apiGetMobilierDamages } from '@/modules/Damage/services/damages'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_RESULT_DECLARATION,
  UPDATE_LOADER
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { FLOW_TRANSITIONS } from '@/modules/Flow/constants'
import { FLOW_MODULE_NAME } from '@/modules/Flow/store/types'
import cloneDeep from 'lodash/cloneDeep'
import { billmaChangeE2EFlow } from '@/modules/Claim/services/sinister'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'damageMobilierValidation',

  mixins: [flowMixin],

  components: {
    maButtonsNextActions,
    maAccordion,
    maModal,
    maNavbarStepper
  },
  data() {
    return {
      isMobilierDamage: false,
      mobilierDamages: [],
      damagesList: [],
      damagesArray: [],
      mobilierDamagesAmmounts: {}
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyHasUpptecDamage: 'hasUpptecDamage',
      stateWarrantyResultDeclaration: 'resultDeclaration',
      stateWarrantySinisterSummary: 'sinisterSummary',
      stateWarrantyWarranties: 'warranties'
    }),
    ...mapState(FLOW_MODULE_NAME, {
      stateFlowState: 'flowState',
      stateFlowViewOptions: 'flowViewOptions'
    }),

    ...mapState(['date']),

    isFrais() {
      return (
        this.stateFlowViewOptions.smart_values.frais.compensation_base !== 0
      )
    },
    isOptionRAN() {
      return (
        this.stateFlowViewOptions.smart_values.optionRAN === 'Oui'
      )
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actGetResultDeclaration: WARRANTY_GET_RESULT_DECLARATION
    }),

    ...mapMutations({
      updateLoader: UPDATE_LOADER
    }),

    ...mapMutations(['setNewDate']),

    updateStateWithDate() {
      this.$store.commit('setNewDate', this.date)
      return this.date
    },

    handleClickUppTecDossier() {
      apiGetUpptecPdf(this.getSinisterId).then((data) => {
        downloadBlobFile(data, 'Upptec_Dossier.pdf')
      })
        .catch((error) => {
          const context = {
            component: 'damageMobilierValidation',
            method: 'handleClickUppTecDossier',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error downloading Upptec PDF: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getWarrantyId,
            'handleClickUppTecDossier'
          )
        })
    },
    mapMobilierDamages(data) {
      // TODO: update mapper when specific mobilier damages is created
      const { warranties } = data
      const { mobilier: mobilierDamages } = warranties
      if (!mobilierDamages) return []
      const { damages: mobilierDamagesArray } = mobilierDamages

      return mobilierDamagesArray.map((damageData) => {
        const { damage } = damageData
        return {
          name: (damage?.description?.split(',')[0]) || '-',
          date: (damage?.purchase_date) || '-',
          reference: (damage?.original_product?.model) || '-',
          amount: (damageData?.artessian_repair?.market_price_with_taxes) || 0,
          category: damage?.category?.split(',')[1],
          brand: damage?.original_product?.brand,
          product: damage?.product?.split(',')[0]
        }
      })
    },

    async setMobilierDamages() {
      try {
        if (!this.getSinisterId) return
        const mobilierDamages = await apiGetMobilierDamages(this.getSinisterId)
        this.mobilierDamages = this.mapMobilierDamages(mobilierDamages)
      } catch (error) {
        const context = {
          component: 'damageMobilierValidation',
          method: 'setMobilierDamages',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context, { willRedirect: true })

        this.sendSentryError(
          `Error getting mobilier damages: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getWarrantyId,
          'setMobilierDamages'
        )

        this.goToErrorView()
      }
    },

    setDamagesData() {
      this.damagesList = cloneDeep(
        this.stateWarrantyWarranties.mobilier.damages
      )
    },
    handleOpenDescriptionModal() {
      this.$refs.modalDescription.showModal = true
    },
    handleCloseDescriptionModal() {
      this.$refs.modalDescription.showModal = false
    },

    /**
     * This method handles the API call related to generate a pdf materials
     * list report.
     */
    // handleClickMaterialList() {
    //   apiGetPdfMaterial(this.getSinisterId).then((data) => {
    //     downloadBlobFile(data, 'Material_summary.pdf')
    //   })
    // },
    // handleCloseDescriptionModal() {
    //   this.$refs.modalDescription.showModal = false
    // },

    handlePrimaryButtonClick() {
      if (this.isFrais) {
        this.goToNextState(FLOW_TRANSITIONS.SHOW_FRAIS)
      } else if (
        this.getFlowState === 'REN_DETAILS' ||
        this.getFlowState === 'BILLMA'
      ) {
        this.goToNextState(FLOW_TRANSITIONS.SHOW_RESUME, {
          date: this.updateStateWithDate()
        })
      } else {
        this.goToNextState(FLOW_TRANSITIONS.MOBILIER_FINISHED_OK, {
          date: this.updateStateWithDate()
        })
      }
    },

    async handleSecondaryButtonClick() {
      if (this.isE2EFlow) {
        await billmaChangeE2EFlow(this.getSinisterId, 'mobilier')
      }
      this.goToNextState(FLOW_TRANSITIONS.CALLBACK_REQUEST)
    },

    handleTertiaryButtonClick() {
      this.goToNextState(FLOW_TRANSITIONS.SHOW_COMPENSATION_TYPE)
    },
    handleAmmountsDamages() {
      this.mobilierDamagesAmmounts = cloneDeep(
        this.stateFlowViewOptions.smart_values.mobilier
      )
    },
    replaceDots(value) {
      if (value) {
        if (typeof value === 'number') {
          value = value.toString()
        }
        let valueComma = value.replace(/\./g, ',')

        return valueComma
      }
    },
    hasDepreciation() {
      if (this.mobilierDamagesAmmounts?.damages) {
        return this.mobilierDamagesAmmounts.damages.some(damage => damage.deprecation > 0)
      }
    }
  },
  mounted() {
    this.handleAmmountsDamages()
    this.updateLoader(true)
    this.actGetResultDeclaration(this.getSinisterId)
    this.setMobilierDamages()
    this.updateLoader(false)
    this.setDamagesData()
  }
}
